import React from 'react'
import { graphql, Link} from 'gatsby'
import { RichText} from 'prismic-reactjs'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './form.css'
import ContactForm from './contactForm';

export const csuPageData = graphql `
query 
{  
  allPrismicCsu {
    edges {
      node {
        data {
          about_csu_summary {
            text
            direction
            type
            spans {
              end
              start
              type
            }
          }
          categories {
            short_name
            long_name
            group_to_email
            is_active
          }
          email_and_phone {
            text
            direction
            spans {
              data {
                link_type
                target
                url
              }
              end
              start
              type
            }
            type
          }
          faq_link {
            url
          }
          mailing_address {
            text
            direction
            spans {
              end
              start
              type
            }
            type
          }
        }
      }
    }
  }
}
`


const CSU = (props) => {
    console.log('Props:', props);
    console.log('Data:', props.data);
    const csuData = props.data;
    const allPrismicCSUStuff = csuData.allPrismicsu;
    console.log('Edges:', allPrismicCSUStuff);

    const csuPageInfo = props.data.allPrismicCsu.edges[0].node.data;
    // const staffLeftColumn = aboutPageInfo.staff_group.filter(group => group.display_column === "Left").sort((g1, g2) => g1.display_order - g2.display_order);
    // const staffRightColumn = aboutPageInfo.staff_group.filter(group => group.display_column === "Right").sort((g1, g2) => g1.display_order - g2.display_order);
    if (typeof window !== "undefined"){
        return (
        <Layout>
            <SEO title="About the Constituent Services Unit" description="General information about the Constituent Services Unit of Research Division" pathname={props.location.pathname}/>
            <Row>
                <Col lg={9} className="text-left">
                    <h1>About the Constituent Services Unit</h1> 
                </Col>
                <Col lg={3} className="text-lg-right pr-lg-3 pt-2 pt-lg-0">
                <p className="h5 font-weight-bold">Other Options</p>
                <p className="h6">
                    <a className="animated" href="/Division/Research/Content/">Browse our Featured Content</a>
                </p>
                <p className="h6">
                    <Link className="animated" to="/Contact">Contact Us</Link>
                </p>
                </Col>
            </Row>
            <hr className="my-4"/> 
            <Row>
                <Col className="text-left">
                {csuPageInfo.about_csu_summary.map((item,index) =>(
                    <div key={index}>
                        <p>
                            <RichText render={[item]} />
                        </p>
                    </div>
                ))}
                </Col>
            </Row>
            <Row>
                <Col className="text-left">
                {csuPageInfo.email_and_phone.map((item,index) =>(
                    <div key={index}>
                        <RichText render={[item]}/>
                    </div>
                ))}
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col className="text-left">
                    <a href={csuPageInfo.faq_link.url} target={csuPageInfo.faq_link.target || 'self'}>Frequently Asked Questions</a>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col className="text-left">
                <p>
                <RichText render={csuPageInfo.mailing_address}/>
                </p>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col>
                <h2 className="mb-2">Send Us a Message</h2>
                <ContactForm categories={csuPageInfo.categories}/>
                </Col>
            </Row>
        </Layout>
    )
    }
    else {
        return null
    }
        
}

export default CSU